const icon = require('vue-svgicon');
icon.register({
    'plus': {
        width: 37,
        height: 36,
        viewBox: '0 0 37 36',
        data: `<path pid="0" d="M18.902 0v36M36.902 18h-36" _stroke="#000" stroke-width="2"/>`,
    },
});
